// extracted by mini-css-extract-plugin
export var container = "expanded-module--container--990b8";
export var rightBackgroundIcon = "expanded-module--rightBackgroundIcon--535da";